var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_136_60)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9782 11.9916C23.9782 18.6076 18.6149 23.9709 11.9989 23.9709C5.38287 23.9709 0.0195312 18.6076 0.0195312 11.9916C0.0195312 5.37554 5.38287 0.012207 11.9989 0.012207C18.6149 0.012207 23.9782 5.37554 23.9782 11.9916ZM17.4945 8.79378C18.0628 8.72607 18.6045 8.57521 19.1085 8.35236C18.7305 8.91614 18.255 9.4081 17.7045 9.80521C17.7105 9.92606 17.7131 10.0461 17.7131 10.1678C17.7131 13.8715 14.8854 18.1426 9.71601 18.1426C8.18868 18.144 6.69309 17.7067 5.40718 16.8826C6.8933 17.0624 8.39003 16.645 9.56858 15.722C8.98285 15.7114 8.41505 15.5183 7.94439 15.1695C7.47373 14.8207 7.12371 14.3336 6.94317 13.7763C7.36447 13.8574 7.79876 13.8407 8.21259 13.7275C7.57739 13.6 7.00584 13.2567 6.59495 12.7559C6.18405 12.255 5.95912 11.6273 5.95832 10.9795V10.9435C6.34866 11.16 6.78503 11.2801 7.23117 11.2941C6.63612 10.899 6.21458 10.2914 6.05284 9.59573C5.89111 8.90003 6.00141 8.16882 6.36117 7.55179C7.06815 8.41838 7.94922 9.12686 8.94734 9.63139C9.94546 10.1359 11.0384 10.4252 12.1554 10.4806C12.0597 10.0687 12.0583 9.64053 12.1514 9.22802C12.2444 8.81551 12.4295 8.42937 12.6927 8.09844C12.956 7.76751 13.2906 7.50035 13.6717 7.31694C14.0527 7.13352 14.4702 7.03858 14.8931 7.03922C15.2774 7.03853 15.6578 7.11667 16.0108 7.26882C16.3637 7.42096 16.6817 7.64388 16.9451 7.92379C17.5747 7.80041 18.1785 7.57023 18.7305 7.24322C18.5204 7.893 18.0811 8.44414 17.4945 8.79378Z",
    fill: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_136_60"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.9998,
    height: 23.9998,
    fill: "white",
    transform: "translate(0 0.000488281)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.f1e67a0c.svg";
export { ForwardRef as ReactComponent };